import React from "react";
import Header from "../components/Header";
import ValueEngineHero from "../components/ValueEngineHero";
import PlateBand from "../components/PlateBand";
import ValueDashboardSection from "../components/ValueDashboardSection";
import ValueModulesSection from "../components/ValueModulesSection";
import ValueBenefitsSection from "../components/ValueBenefitsSection";
// Abschnitt "Unsere Kunden" vorerst deaktiviert (Wunsch Alexander, 19.08.2026).
// Zum Wiederherstellen: diese Zeile und <ClientsSection /> unten einkommentieren.
// import ClientsSection from "../components/ClientsSection";
import NewsletterSection from "../components/NewsletterSection";
import LatestInsightsSection from "../components/LatestInsightsSection";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";
import AISearchOptimization from "../components/AISearchOptimization";
import AIOptimizedFAQ from "../components/AIOptimizedFAQ";

// Get base URL for structured data
const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_SITE_URL;
  if (envUrl && envUrl.includes('brovko.de')) {
    return 'https://brovko.de';
  }
  if (envUrl) {
    return envUrl;
  }
  return 'https://brovko.de';
};

const Home = () => {
  const baseUrl = getBaseUrl();
  
  const homeSEO = {
    title: "BROVKO - KI-Value-Engine | KI-Transformation messbar machen",
    description: "Von der Probierstube zur steuerbaren Wertmaschine. Portfolio-Steuerung, Value-Dashboard und Operating Rhythm für messbare KI-Erfolge. Jetzt Value-Check starten!",
    keywords: "KI-Value-Engine, KI-Transformation messbar, AI Value Dashboard, Portfolio-Steuerung KI, Operating Rhythm, EBIT Impact KI, ROI KI-Projekte",
    canonicalUrl: "/",
    ogTitle: "BROVKO - KI-Value-Engine | KI-Transformation messbar machen",
    ogDescription: "Von der Probierstube zur steuerbaren Wertmaschine. Portfolio-Steuerung, Value-Dashboard und Operating Rhythm für messbare KI-Erfolge.",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "BROVKO",
      "alternateName": "KI-Value-Engine",
      "url": baseUrl,
      "logo": `${baseUrl}/favicon.svg`,
      "description": "BROVKO macht KI-Transformation messbar. Mit der KI-Value-Engine transformieren wir Pilotprojekte in steuerbare Wertschöpfung.",
      "foundingDate": "2011",
      "slogan": "KI-Transformation messbar machen",
      "areaServed": ["DE", "AT", "CH"],
      "serviceType": [
        "KI-Value-Engine",
        "Portfolio-Steuerung",
        "Value-Dashboard",
        "Operating Rhythm",
        "KI-Beratung",
        "EBIT-Impact Messung"
      ],
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "DE"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "email": "email@brovko.de",
        "availableLanguage": ["German", "English"]
      }
    }
  };

  // theme-brand schaltet die shadcn-Tokens auf das dunkle Marken-Theme
  return (
    <div className="theme-brand min-h-screen bg-surface text-ink">
      <SEOHead {...homeSEO} />
      <Header />
      <ValueEngineHero />
      <PlateBand />
      <ValueDashboardSection />
      <ValueModulesSection />
      <ValueBenefitsSection />
      <AIOptimizedFAQ />
      {/* <ClientsSection /> */}
      <LatestInsightsSection />
      <NewsletterSection />
      <Footer />
      
      {/* AI Search Optimization */}
      <AISearchOptimization 
        pageType="homepage"
        title="BROVKO - KI-Value-Engine | KI-Transformation messbar machen"
        description="Von der Probierstube zur steuerbaren Wertmaschine. Portfolio-Steuerung, Value-Dashboard und Operating Rhythm für messbare KI-Erfolge."
        keywords={[
          'KI-Value-Engine',
          'KI-Transformation messbar',
          'AI Value Dashboard',
          'Portfolio-Steuerung KI',
          'Operating Rhythm',
          'EBIT Impact KI',
          'ROI KI-Projekte',
          'Value-Check KI'
        ]}
      />
    </div>
  );
};

export default Home;
